import { render } from "./DadosDaLoja.vue?vue&type=template&id=2c11ad66&scoped=true&ts=true"
import script from "./DadosDaLoja.vue?vue&type=script&lang=ts"
export * from "./DadosDaLoja.vue?vue&type=script&lang=ts"

import "./DadosDaLoja.vue?vue&type=style&index=0&id=2c11ad66&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c11ad66"]])

export default __exports__